// extracted by mini-css-extract-plugin
export default {"modal-header":"AddHolidayManuallyModal_modal-header__6c1pg","form-container-head-warning":"AddHolidayManuallyModal_form-container-head-warning__4TEyQ"};